"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _atoms = require("../../atoms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SessionHeader = function SessionHeader(_ref) {
  var brandLogo = _ref.brandLogo,
      userSessionFullName = _ref.userSessionFullName,
      handleLogout = _ref.handleLogout,
      logoutLabel = _ref.logoutLabel,
      menuLogo = _ref.menuLogo;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "session-header items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "w-4/12 p-0"
  }, brandLogo), /*#__PURE__*/_react.default.createElement("div", {
    className: "w-2/5 flex flex-row justify-end items-center"
  }, userSessionFullName && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "text-white text-right"
  }, userSessionFullName), /*#__PURE__*/_react.default.createElement(_atoms.ActionLink, {
    onClick: handleLogout
  }, logoutLabel)), menuLogo));
};

SessionHeader.propTypes = {
  brandLogo: _propTypes.default.any,
  userSessionFullName: _propTypes.default.string,
  handleLogout: _propTypes.default.func,
  logoutLabel: _propTypes.default.string,
  menuLogo: _propTypes.default.any
};
var _default = SessionHeader;
exports.default = _default;